export default {
    pageName: 'ภาพรวมการมาทำงาน',
    search: {
        title: '',
        placeholder: 'ค้นหารหัสพนักงาน'
    },
    people: 'คน',
    detail: {
        title: 'รายละเอียด',
        present: 'ตรงเวลา',
        late: 'สาย',
        halfDay: 'ขาดครึ่งวัน',
        absent: 'ขาดเต็มวัน',
        leave: 'ลา'
    },
    header: {
        detail: 'รายละเอียด',
        status: 'สถานะ'
    }
}
